export enum FORMS_LIBRARY_ASSET_KEYS {
  SAMPLE_ICON = 'SAMPLE_ICON',
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  LEFT_ARROW_ICON = 'LEFT_ARROW_ICON',
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  LEFT_ARROW_BLACK_ICON = 'LEFT_ARROW_BLACK_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  CLOSE_ICON = 'CLOSE_ICON',
  FORM_ICON = 'FORM_ICON',
  VISUAL_ICON = 'VISUAL_ICON',
  ATTENTION_ICON = 'ATTENTION_ICON',
  ATTACHMENT_ICON = 'ATTACHMENT_ICON',
  ADD_ICON = 'ADD_ICON',
  FRAUD_ICON = 'FRAUD_ICON',
  CHECK_ICON = 'CHECK_ICON',
  NO_FORM_AVAILABLE = 'NO_FORM_AVAILABLE',
  CALENDAR_ICON = 'CALENDAR_ICON',
  IMAGE_ICON = 'IMAGE_ICON',
  PDF_ICON = 'PDF_ICON',
  DOC_ICON = 'DOC_ICON',
}

export type FormsLibraryAssets = Record<FORMS_LIBRARY_ASSET_KEYS, unknown>;
